import * as React from "react";
import { Alert, Button, Card, Tabs } from "antd";
import { ExternalInbound } from "./externalInbound";
import { ExternalOutbound } from "./externalOutbound";
import { Internal } from "./internal";
import { CardTitle } from "../../../../components/antd/card/CardTitle";
import { CardContent } from "../../../../components/antd/card/CardContent";
import { formSetValue, useCpFormValue } from "../../../gvc/testNewForm/utils";
import { CpErrorWarningArrayIcon } from "../../../gvc/testNewForm/CpErrorWarningArrayIcon";
import { useCpFormContext } from "../../../../components/form/useCpFormContext";
import { TabLabel } from "../tabLabel";

interface Props {}
export const WorkloadFirewallConfig: React.FC<Props> = () => {
  const { id } = useCpFormContext();
  const type = useCpFormValue("type");
  const inboundPublic = useCpFormValue(`firewallConfig.external.inbound.public`);

  return (
    <div className="cpln-form-section cpln-ant-card-container">
      <Card>
        <CardTitle>
          <div className="flex items-center gap-2">
            <div>
              Firewall
              <CpErrorWarningArrayIcon names={[`firewallConfig`]} />
            </div>
          </div>
          {inboundPublic || type === "cron" ? null : (
            <Alert
              type={`warning`}
              className={`small w-fit my-2`}
              message={
                <div className="flex items-center gap-2">
                  <div>Internet access to this workload is restricted.</div>
                  <Button
                    htmlType={`button`}
                    onClick={() => formSetValue(id, `firewallConfig.external.inbound.public`, true)}
                    size={`small`}
                  >
                    Make Public
                  </Button>
                </div>
              }
            />
          )}
        </CardTitle>
        <CardContent>
          <Tabs
            type={`card`}
            defaultActiveKey={type === "cron" ? "external-outbound" : "external-inbound"}
            items={[
              ...(type === "cron"
                ? []
                : [
                    {
                      key: "external-inbound",
                      label: <TabLabel label="External | Inbound" names={["firewallConfig.external.inbound", "firewallConfig.external.httpInboundHeaderFilter"]} showDirty />,
                      children: (
                        <div className="pt-6">
                          <ExternalInbound />
                        </div>
                      ),
                    },
                  ]),
              {
                key: "external-outbound",
                label: <TabLabel label="External | Outbound" names={["firewallConfig.external.outbound"]} showDirty />,
                children: (
                  <div className="pt-6">
                    <ExternalOutbound />
                  </div>
                ),
              },
              ...(type === "cron"
                ? []
                : [
                    {
                      key: "internal",
                      label: <TabLabel label="Internal" names={["firewallConfig.internal"]} showDirty />,
                      children: (
                        <div className="pt-6">
                          <Internal />
                        </div>
                      ),
                    },
                  ]),
            ]}
          />
        </CardContent>
      </Card>
    </div>
  );
};
